import { useEffect, useState, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabaseClient";
import WhatsAppPrompt from "@/components/feature/WhatsAppPrompt";

/**
 * Protege las rutas /app/* — si no hay sesión de Supabase activa, manda
 * de vuelta al login. Mientras se confirma la sesión muestra un loader
 * simple en vez de parpadear el contenido protegido.
 */
export default function RequireAuth({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    let active = true;

    supabase.auth.getSession().then(({ data }) => {
      if (!active) return;
      if (data.session) {
        setAuthed(true);
        setChecking(false);
      } else {
        navigate("/", { replace: true });
      }
    });

    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!session) {
        navigate("/", { replace: true });
      }
    });

    return () => {
      active = false;
      sub.subscription.unsubscribe();
    };
  }, [navigate]);

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-950">
        <i className="ri-loader-4-line animate-spin text-3xl text-primary-400"></i>
      </div>
    );
  }

  if (!authed) return null;

  return (
    <>
      {children}
      <WhatsAppPrompt />
    </>
  );
}
